import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { CheckingAccountsResponseDTO } from "../checking-account-client.dto";

export class GetCheckingAccountClientCommand extends IRequestCommand<
  IGetCheckingAccountClientResponse,
  ErrorDetails,
  IGetCheckingAccountClientParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = "checking-accounts/carrier/{carrierId}/clients/paginated?page={page}&size={size}&column={column}&sort={sort}&find={find}&type={typeFilter}"

  public override setParameters(parameters: IGetCheckingAccountClientParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId ? parameters.carrierId.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{page}',
      parameters.page ? parameters.page.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      parameters.size ? parameters.size.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      parameters.column ? parameters.column.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      parameters.sort ? parameters.sort.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{find}',
      parameters.find ? parameters.find.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{typeFilter}',
      parameters.typeFilter ? parameters.typeFilter.toString() : ''
    );
  }
}

export interface IGetCheckingAccountClientParameters {
    carrierId: number;
    page?: number;
    size?: number;
    column?: string;
    sort?: string;
    find?: string;
    typeFilter?: string;
}

export interface IGetCheckingAccountClientResponse extends ICommandResponse, CheckingAccountsResponseDTO {
}
